<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-20 17:34:34
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 13:50:52
 * @FilePath: /privacy-web/src/components/PrivacyManage/ManagementGuideContent.vue
-->
<template>
  <div
    class="Management-guide-content-main"
    :class="{ 'Management-guide-content-main-mobile': isMobile }"
  >
    <div class="main">
      <ManagementGuideContentItem :data="dataList"></ManagementGuideContentItem>
    </div>
    <!-- <div class="circle" :style="{background: ` url('~assets/images/privacyManage/iphone1.png') no-repeat;`}"></div> -->
  </div>
</template>
<script>
export default {
  name: "ManagementGuideContent",
  data() {
    return {
      list: [],
      dataList: [
        {
          guide:[],
          "productLogo":"https://devlawtrust-1306822285.cos.ap-beijing.myqcloud.com/banner/product-icon.png",
          "productName":"贝壳"
        }
      ],
    };
  },
  async created() {
    this.readDictByKey("privacyAdminGuide", (res) => {
      this.list = res.list.item;
      this.dataList = res.list.item.filter(
        (a) => a.productName === this.$store.state.app.type
      );
    });
  },
  computed: {
    types() {
      return this.$store.state.app.type;
    },
  },
  watch: {
    types: {
      deep: true,
      handler(newValue, oldValue) {
        this.dataList = this.list.filter((a) => a.productName === newValue);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.Management-guide-content-main {
  margin-top: calc($multiple * 108px);
  height: calc($multiple * 480px);
  width: 100%;
  position: relative;
  .circle {
    position: absolute;
    top: 0;
    left: calc($multiple * 530px);
    width: calc($multiple * 415px);
    height: calc($multiple * 829px);
    /* background: url('~assets/images/privacyManage/iphone1.png') no-repeat; */
    background-size: 100%;
  }
}
.Management-guide-content-main-mobile {
  margin-top: 1.41rem;
  padding: 0 1.02rem;
  height: 17.5rem;
  .main {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .circle {
    position: relative;
    top: 1.24rem;
    /* left: 2.5rem; */
    width: 12.2rem;
    /* height: 14.3rem; */
    /* background: url('~assets/images/privacyManage/iphone1.png') no-repeat; */
    background-size: 100%;
  }
}
</style>
